import React from "react";
import { Upload } from "antd";

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imageList: ''
        }
    }
    componentDidMount() {
        const { toson } = this.props
        // console.log(toson);
        this.setState({
            imageList: toson
        })
    }
    render() {
        const { imageList } = this.state
        const fileList = []
        return (
            <div>
                {imageList.split(",").map((x, y) => {
                    let extension = x.substring(x.lastIndexOf('.'), x.length)
                    fileList.push({
                        uid: y,
                        name: 'image'+extension,
                        status: 'done',
                        url: x
                    })
                })}
                <Upload fileList={fileList} key={fileList.uid} listType="text" showUploadList={{ showRemoveIcon: false }} className='link'></Upload>
            </div>
        )
    }
}



export default Footer
